import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Q9Graph} from './graph/graph';
import {EditorRegistryService} from './editor/editor-registry.service';
import {EditorService} from './editor/editor.service';
import {EditorUiService} from './editor/editor-ui.service';
import {TextEditingStylesService} from './graph/text-editing-styles.service';
import {MxCellExtend} from './graph/mxCell.extend';

@NgModule({
  imports: [CommonModule],
  providers: [
    Q9Graph,
    EditorRegistryService,
    MxCellExtend,
    EditorService,
    EditorUiService,
    TextEditingStylesService
  ],
  declarations: []
})
export class MxGraphModule {}
